(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jb-bag-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jb-bag-preview')) {
  customElements.define('jb-bag-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.controller || !this.showPopover) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.media = matchMedia('(min-width:1025px) and (hover:hover) and (pointer:fine)');
      this.triggers = [...document.querySelectorAll('[data-cart-drawer-toggle], #cart-drawer-toggle')];
      this.original = new Map(this.triggers.map(trigger => [trigger, ['aria-controls','aria-expanded','aria-haspopup'].map(name => [name, trigger.getAttribute(name)])]));
      const adapt = () => {
        this.close();
        this.triggers.forEach(trigger => {
          if (this.media.matches) {
            trigger.setAttribute('aria-controls', this.id);
            trigger.setAttribute('aria-expanded', 'false');
            trigger.setAttribute('aria-haspopup', 'dialog');
          } else this.original.get(trigger).forEach(([name,value]) => value === null ? trigger.removeAttribute(name) : trigger.setAttribute(name,value));
        });
      };
      this.media.addEventListener('change', adapt, {signal});
      this.triggers.forEach(trigger => {
        trigger.addEventListener('pointerenter', event => {
          if (!this.media.matches || event.pointerType === 'touch') return;
          clearTimeout(this.closeTimer);
          clearTimeout(this.openTimer);
          this.openTimer = setTimeout(() => this.open(trigger), 1000);
        }, {signal});
        trigger.addEventListener('pointerleave', event => {if (!this.contains(event.relatedTarget)) this.scheduleClose();}, {signal});
        trigger.addEventListener('keydown', event => {
          if (this.media.matches && event.key === 'ArrowDown') {
            event.preventDefault();
            this.open(trigger);
            this.querySelector('a')?.focus();
          }
        }, {signal});
      });
      this.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), {signal});
      this.addEventListener('pointerleave', () => this.scheduleClose(), {signal});
      this.addEventListener('focusout', event => {if (!this.contains(event.relatedTarget)) this.close();}, {signal});
      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || !this.matches(':popover-open')) return;
        const returnFocus = this.contains(document.activeElement);
        this.close();
        if (returnFocus) this.anchor?.focus({preventScroll:true});
      }, {signal});
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target) && !this.triggers.some(trigger => trigger.contains(event.target))) this.close();
      }, {signal});
      document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-cart-drawer-toggle], #cart-drawer-toggle');
        if (!trigger || !this.media.matches || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        this.close();
        event.stopImmediatePropagation();
      }, {capture:true,signal});
      document.addEventListener('panel:open', () => this.close(), {signal});
      document.addEventListener('cart:rendered', () => this.sync(), {signal});
      window.addEventListener('resize', () => this.close(), {signal});
      window.addEventListener('scroll', () => this.close(), {passive:true,signal});
      window.addEventListener('pagehide', () => this.close(), {signal});
      adapt();
    }
    open(trigger) {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      if (!this.media.matches || document.querySelector('.side-panel.active,dialog[open],.jb-drawer.is-open')) return;
      const rect = trigger.getBoundingClientRect();
      if (!rect.width || rect.bottom < 0) return;
      this.anchor = trigger;
      this.sync();
      const width = Math.min(360, innerWidth - 40);
      this.style.setProperty('--bag-preview-left', `${Math.max(20, Math.min(rect.right - width, innerWidth - width - 20))}px`);
      this.style.setProperty('--bag-preview-top', `${rect.bottom + 30}px`);
      if (!this.matches(':popover-open')) this.showPopover();
      trigger.setAttribute('aria-expanded', 'true');
    }
    sync() {
      const source = document.querySelector('#Cart-Drawer template[data-bag-preview-template]');
      if (!source || this.contains(document.activeElement)) return;
      this.querySelector('[data-bag-preview-content]').replaceChildren(source.content.cloneNode(true));
    }
    scheduleClose() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      if (!this.contains(document.activeElement)) this.closeTimer = setTimeout(() => this.close(), 300);
    }
    close() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      if (this.matches(':popover-open')) this.hidePopover();
      if (this.media?.matches) this.triggers?.forEach(trigger => trigger.setAttribute('aria-expanded','false'));
    }
    disconnectedCallback() {
      this.close();
      this.controller?.abort();
      this.controller = null;
      this.original?.forEach((attributes,trigger) => attributes.forEach(([name,value]) => value === null ? trigger.removeAttribute(name) : trigger.setAttribute(name,value)));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jb-collection-hero"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jb-category-media')) {
  customElements.define('jb-category-media', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.choices = [...this.querySelectorAll('template[data-media]')].map(template => ({ template, query: matchMedia(template.dataset.media) }));
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = this.motion.matches;
      this.visible = !('IntersectionObserver' in window);
      this.choices.forEach(({ query }) => query.addEventListener('change', () => this.update(), options));
      this.motion.addEventListener('change', () => { this.userPaused = this.motion.matches; this.update(); }, options);
      document.addEventListener('visibilitychange', () => this.update(), options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.update();
        }, { threshold: 0.1 });
        this.observer.observe(this);
      }
      this.update();
    }
    update() {
      if (!this.controller || !this.isConnected) return;
      const selected = this.choices.find(choice => choice.query.matches)?.template;
      if (selected !== this.selected) {
        this.release();
        this.selected = selected;
        this.blocked = false;
      }
      const shouldPlay = selected && this.visible && !document.hidden && !this.userPaused && !this.blocked;
      if (shouldPlay && !this.video) {
        this.video = selected.content.querySelector('video').cloneNode(true);
        this.video.muted = true;
        this.video.playsInline = true;
        this.video.loop = true;
        this.video.preload = 'auto';
        const video = this.video;
        video.addEventListener('playing', () => {
          if (video !== this.video) return;
          video.classList.add('is-ready');
        }, { signal: this.controller.signal });
        video.addEventListener('error', () => {
          if (video !== this.video) return;
          video.classList.remove('is-ready');
          this.blocked = true;
          this.userPaused = true;
        }, { signal: this.controller.signal });
        this.append(video);
      }
      if (this.video) {
        if (!shouldPlay) this.video.pause();
        else if (this.video.paused && !this.pending) {
          const video = this.video;
          const pending = video.play();
          this.pending = pending;
          Promise.resolve(pending).catch(() => {
            if (this.video === video && this.visible && !document.hidden && !this.userPaused) {
              this.blocked = true;
              this.userPaused = true;
            }
          }).finally(() => {
            if (this.video !== video) return;
            this.pending = null;
          });
        }
      }
    }
    release() {
      if (this.video) {
        this.video.pause();
        this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
        this.video.removeAttribute('src');
        this.video.load();
        this.video.remove();
      }
      this.video = null;
      this.pending = null;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.release();
      this.controller = null;
      this.selected = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jb-editorial-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jb-editorial-carousel')) {
  customElements.define('jb-editorial-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.track = this.querySelector('.jb-maison-carousel__track');
      this.cards = Array.from(this.track.children);
      this.controls = this.querySelector('.jb-maison-carousel__controls');
      this.previous = this.querySelector('[data-carousel-previous]');
      this.next = this.querySelector('[data-carousel-next]');
      this.pages = this.querySelector('.jb-maison-carousel__pages');
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('pointerdown', () => this.stop(), options);
      this.track.addEventListener('wheel', () => this.stop(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault(); this.go(event.key === 'Home' ? 0 : this.maximum());
        }
      }, options);
      this.observer = new ResizeObserver(() => this.layout());
      this.observer.observe(this.track);
      this.layout();
    }
    stop() { cancelAnimationFrame(this.frame); this.track.style.scrollSnapType = ''; }
    maximum() { return Math.max(0, this.track.scrollWidth - this.track.clientWidth); }
    layout() {
      const start = this.cards[0]?.offsetLeft || 0;
      this.stops = [...new Set([0, ...this.cards.map(card => Math.min(this.maximum(), Math.max(0, card.offsetLeft - start)))])];
      this.pages.replaceChildren();
      this.stops.forEach((stop, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', this.cards[index]?.querySelector('h2,h3')?.textContent.trim() || String(index + 1));
        button.setAttribute('aria-controls', this.track.id);
        button.addEventListener('click', () => this.go(stop), { signal: this.controller.signal });
        this.pages.append(button);
      });
      this.controls.hidden = this.maximum() < 2;
      this.update();
    }
    update() {
      const x = this.track.scrollLeft;
      this.previous.disabled = x < 2;
      this.next.disabled = x > this.maximum() - 2;
      const index = this.stops.reduce((best, stop, i) => Math.abs(stop - x) < Math.abs(this.stops[best] - x) ? i : best, 0);
      Array.from(this.pages.children).forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
    }
    move(direction) {
      const x = this.track.scrollLeft;
      const target = direction > 0 ? this.stops.find(stop => stop > x + 2) : [...this.stops].reverse().find(stop => stop < x - 2);
      this.go(target === undefined ? direction > 0 ? this.maximum() : 0 : target);
    }
    go(target) {
      cancelAnimationFrame(this.frame);
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) { this.track.scrollLeft = target; return; }
      const from = this.track.scrollLeft;
      const begin = performance.now();
      this.track.style.scrollSnapType = 'none';
      const tick = now => {
        const t = Math.min(1, (now - begin) / 500);
        let low = 0, high = 1, u = t;
        for (let i = 0; i < 10; i++) {
          const x = 3 * (1 - u) * (1 - u) * u * .25 + 3 * (1 - u) * u * u * .25 + u * u * u;
          if (x < t) low = u; else high = u;
          u = (low + high) / 2;
        }
        const eased = 3 * (1 - u) * (1 - u) * u * .1 + 3 * (1 - u) * u * u + u * u * u;
        this.track.scrollLeft = from + (target - from) * (t === 1 ? 1 : eased);
        if (t < 1) this.frame = requestAnimationFrame(tick);
        else this.track.style.scrollSnapType = '';
      };
      this.frame = requestAnimationFrame(tick);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
      if (this.track) this.track.style.scrollSnapType = '';
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jb-interaction-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    if (document.documentElement.hasAttribute('data-jb-motion-ready')) return;
    document.documentElement.setAttribute('data-jb-motion-ready', '');
    const links = [
      '.jb-product-services a',
      '.jb-product-services button',
      '.jb-product-share button',
      '.jb-product-policies a',
      '.jb-first-details summary',
      '.jb-first-services summary',
      '.jb-product-breadcrumb a',
      '.jb-reference-footer__group a',
      '.jb-footer-sitemap a'
    ].join(',');
    const targets = '.jb-motion-link,.jb-product-experience .jb-material-options label';
    let pointed = null;
    let pressed = null;
    let touchId = null;
    let releaseTimer = 0;

    const prepare = root => {
      if (root.nodeType !== 1 && root.nodeType !== 9) return;
      const candidates = [...root.querySelectorAll(links)];
      if (root.matches?.(links)) candidates.unshift(root);
      candidates.forEach(link => {
        if (link.classList.contains('jb-motion-link')) return;
        let wrapped = false;
        [...link.childNodes].forEach(node => {
          if (node.nodeType !== 3 || !node.textContent.trim()) return;
          const label = document.createElement('span');
          label.className = 'jb-motion__label';
          node.replaceWith(label);
          label.append(node);
          wrapped = true;
        });
        if (wrapped) link.classList.add('jb-motion-link');
      });
    };
    const targetAt = node => {
      const target = node?.closest?.(targets);
      if (!target || target.matches(':disabled,[aria-disabled="true"]')) return null;
      if (target.tagName === 'LABEL' && target.control?.disabled) return null;
      return target;
    };
    const clearPointed = () => {
      pointed?.classList.remove('is-jb-pointed');
      pointed = null;
    };
    const clearPressed = () => {
      window.clearTimeout(releaseTimer);
      pressed?.classList.remove('is-jb-pressed');
      pressed = null;
      touchId = null;
    };
    const press = target => {
      if (pressed === target) return;
      pressed?.classList.remove('is-jb-pressed');
      pressed = target;
      pressed?.classList.add('is-jb-pressed');
    };
    const passive = { passive: true };

    prepare(document);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(prepare));
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('pointerover', event => {
      if (event.pointerType === 'touch' || touchId !== null) return;
      const target = targetAt(event.target);
      if (pointed === target) return;
      clearPointed();
      pointed = target;
      pointed?.classList.add('is-jb-pointed');
    }, passive);
    document.addEventListener('pointerout', event => {
      if (event.pointerType === 'touch') return;
      if (pointed && !pointed.contains(event.relatedTarget)) clearPointed();
    }, passive);
    document.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'touch' || event.isPrimary === false) return;
      clearPressed();
      clearPointed();
      touchId = event.pointerId;
      press(targetAt(event.target));
    }, passive);
    document.addEventListener('pointermove', event => {
      if (event.pointerId !== touchId) return;
      press(targetAt(document.elementFromPoint(event.clientX, event.clientY)));
    }, passive);
    document.addEventListener('pointerup', event => {
      if (event.pointerId !== touchId) return;
      touchId = null;
      releaseTimer = window.setTimeout(clearPressed, 160);
    }, passive);
    document.addEventListener('pointercancel', event => {
      if (event.pointerId === touchId) clearPressed();
    }, passive);
    window.addEventListener('blur', () => { clearPointed(); clearPressed(); });
    window.addEventListener('pagehide', () => { clearPointed(); clearPressed(); });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) { clearPointed(); clearPressed(); }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
